// extracted by mini-css-extract-plugin
export var actionButton = "_x0-2";
export var card = "_x0-0";
export var disambiguationList = "_x0-3";
export var errorCard = "_x0-4";
export var row = "_x0-1";